import { GzTextareaWithSuggestionsWebComponent } from './component/GzTextareaWithSuggestionsWebComponent';

export { GzTextareaWithSuggestionsWebComponent };
